import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import { loadTicketStatuses, loadTicketCategories, loadSLAPolicies, loadTicketTemplates } from "store/slices/SupportSlice";

const SupportParentPage = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        // Load support configuration data
        dispatch(loadTicketStatuses());
        dispatch(loadTicketCategories());
        dispatch(loadSLAPolicies());
        dispatch(loadTicketTemplates());
    }, [dispatch]);

    return <Outlet />
}

export default SupportParentPage;
